import Service from './baseService';
import { getCompanyId } from '../config';

export const getGeneralLedgerCodesService = () => {
    return Service.get('/customer/general-ledger-codes', { params: { companyId: getCompanyId() } });
};
